"use client";

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
